<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-start pe-5">
                    <h3 class="fw-bold my-4">Our Services for Business Owners</h3>
                    <!-- <h5 class="fw-bold my-4">خدمات متنوع و تخصصی بازار ارزهای دیجیتال</h5>
                    <h6 class="my-4">با استفاده از بروز ترین خدمات حداکثر بازدهی را تجربه کنید</h6> -->
                    <button class="btn-blue mt-5">Free Registration</button>
                </div>
                <div class="col-md-5 text-end">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">Our Services for Business Owners</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        In today’s competitive world, businesses need to leverage modern technologies and innovative approaches to maintain their position and increase profitability. At our company, relying on specialized knowledge and advanced technologies, we offer a variety of solutions to optimize business processes, enhance productivity, and improve decision-making. Our services help business owners grow smarter and discover new opportunities.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-start">
                        <h4 class="fw-bold">Challenges Faced by Business Owners</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    Lack of access to analytical data and informed decision-making
                                </li>
                                <li class="mt-3">
                                    Inefficient management of resources and processes
                                </li>
                                <li class="mt-3">
                                    Intense competition and the need for continuous innovation
                                </li>
                                <li class="mt-3">
                                    Marketing challenges and acquiring new customers
                                </li>
                                <li class="mt-3">
                                    Rising operational costs and decreased productivity
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">Our Solutions for Business Owners</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Business Data Analysis and Management</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Collecting, processing, and analyzing sales, market, and customer data</li>
                                <li>Implementing analytical dashboards for better decision-making</li>
                                <li>Optimizing business processes using data analytics</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img9.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Artificial Intelligence for Enhancing Business Performance</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Utilizing machine learning models to predict sales and customer behavior</li>
                                <li>Optimizing pricing and advertising strategies</li>
                                <li>Automating internal processes and reducing operational costs</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Digital Marketing and Increasing Customer Conversion Rates</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Developing digital marketing strategies tailored to the type of business</li>
                                <li>Optimizing online advertising and managing social media channels</li>
                                <li>Analyzing customer behavior and providing personalized solutions</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img10.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/Secure.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">پیاده‌سازی بلاکچین برای امنیت و شفافیت کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Creating smart contracts to automate transactions</li>
                                <li>Enhancing data security and preventing forgery and fraud</li>
                                <li>Establishing decentralized systems for managing information and payments</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/Secure.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Financial and Investment Process Management and Optimization</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analyzing financial structure and providing recommendations for cost reduction</li>
                                <li>Consulting on smart and profitable investments</li>
                                <li>Managing liquidity and optimizing financial flows</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Custom Business Software Development</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Designing and developing customized management software</li>
                                <li>Integrating various systems to improve organizational efficiency</li>
                                <li>Optimizing existing software to enhance productivity</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Consulting in Digital Transformation and Modern Business Strategies</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Assessing the current business status and providing a digitalization roadmap</li>
                                <li>Optimizing business models based on modern technologies</li>
                                <li>Offering innovative solutions for sustainable growth and development</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img12.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-start">Results and Value Creation for Business Owners</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img13.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increasing Efficiency and Reducing Operational Costs </strong>through Artificial Intelligence and Data Analytics 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increasing Revenue and Profitability </strong>through Digital Marketing and Advertising Optimization 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhancing Information and Transaction Security </strong>by leveraging Blockchain technology 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Improving Information and Transaction Security </strong>through the use of Blockchain technology
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Optimizing Organizational Processes and Resource Management </strong>to Increase Productivity
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img15.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Achieving More Accurate and Intelligent Decision-Making </strong>through the Use of Analytical Data 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img16.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Building a Sustainable, Technology-Based Business Model </strong>for a More Secure Future 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>How can I use your services for my business?</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        You can contact our consulting team to discuss your needs. Our experts will then conduct a thorough analysis of your business and provide tailored solutions.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>Are these services suitable for small businesses as well?</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, our services are designed to meet the needs of small, medium, and large businesses, and they can be customized according to your specific circumstances.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>How can I use data analysis to improve my business performance?</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        We help you collect and analyze data related to sales, customers, and competitors, enabling you to develop better strategies for the growth and development of your business.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>Does using artificial intelligence require technical skills?</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        No, we handle all implementation and execution processes for you, and if needed, we provide the necessary training to your team.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>How long does it take to see the results of these services in my business?</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Depending on the type of services and your business domain, results are usually noticeable in the short term; however, some strategic solutions may require more time to fully show their impact.
                        <br>
                        We are here to support you in leveraging modern technologies to guide your business toward sustainable growth and success. For consultation and more information, feel free to contact us.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
  direction: ltr;
}
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  right: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  right: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>